"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatCurrency = useFormatCurrency;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted as the currency.
 * @see {@link formatCurrency} for more information.
 *
 * @param value Numeric value to format
 * @param options Additional formatting options
 * @returns `value` formatted as the currency
 * @example
  // basic usage
  useFormatCurrency(1234.567);

  // use a custom delimiter
  useFormatCurrency(1234.567, { doubleCurrencyDelimiter: ' | ' });
 */
function useFormatCurrency(value, options) {
  const {
    culture,
    financialSet
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatCurrency)(value, culture, financialSet, options);
}
